<template>
  <el-form ref="dataForm" :model="dataForm" :rules="rules" label-width="204px" :disabled="isReadonly" :class="{ readOnlyStyle: isReadonly }" class="dataForm">
    <!-- 公司类型 -->
    <div class="pt10 messageWrap">
      <p class="messageTitle">{{ $t("enroll.intitle.companyType") }}</p>
      <div class="pt36">
        <el-form-item :label="$t('enroll.intitle.companyTypeLower')" prop="companyType" ref="companyType">
          <el-select v-model="dataForm.companyType" :placeholder="$t('common.placeholder.select')" class="wd500" @change="typeChange">
            <el-option v-for="item of globalFormatList('companyTypeList')" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <info-popover placement="bottom">
            <div class="linkWrap">
              <p class="fs12">
                <span>{{ $t("enroll.intitle.companyTypeTip") }}</span>
                <span>{{ getLanguage == "zh" ? "Private Company Limited by Shares / 私人股份有限公司" : "Private Company Limited by Shares" }}</span>
              </p>
              <p class="pt2">
                <span class="fs12">{{ $t("common.reference") }}</span>
                <a href="https://www.acra.gov.sg/how-to-guides/before-you-start/choosing-a-business-structure" target="_blank" class="lh14">
                  https://www.acra.gov.sg/how-to-guides/before-you-start/choosing-a-business-structure
                </a>
              </p>
            </div>
          </info-popover>
        </el-form-item>
      </div>
    </div>

    <!-- 公司名称 -->
    <div class="pt50 messageWrap companyWrap">
      <p class="messageTitle">
        {{ $t("enroll.intitle.companyNameTitle") }}
      </p>
      <div class="pt36">
        <el-form-item :label="$t('enroll.intitle.companyName01')" prop="proposedCompanyName1" ref="proposedCompanyName1">
          <el-input v-model="dataForm.proposedCompanyName1" :placeholder="$t('common.placeholder.enter')" class="wd340" v-regexFilter="$halfWidthRegex"></el-input>
          <el-form-item prop="proposedCompanyType1" ref="proposedCompanyType1" class="inlineSuffix">
            <el-select v-model="dataForm.proposedCompanyType1" class="wd160">
              <el-option v-for="item in companySuffixTypeList[dataForm.companyType]" :key="`proposedCompanyType1-${item}`" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item :label="$t('enroll.intitle.companyName02')" prop="proposedCompanyName2" ref="proposedCompanyName2">
          <el-input v-model="dataForm.proposedCompanyName2" :placeholder="$t('common.placeholder.enter')" class="wd340" v-regexFilter="$halfWidthRegex"></el-input>
          <el-form-item prop="proposedCompanyType2" ref="proposedCompanyType2" class="inlineSuffix">
            <el-select v-model="dataForm.proposedCompanyType2" class="wd160">
              <el-option v-for="item in companySuffixTypeList[dataForm.companyType]" :key="`proposedCompanyType2-${item}`" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item :label="$t('enroll.intitle.companyName03')" prop="proposedCompanyName3" ref="proposedCompanyName3">
          <el-input v-model="dataForm.proposedCompanyName3" :placeholder="$t('common.placeholder.enter')" class="wd340" v-regexFilter="$halfWidthRegex"></el-input>
          <el-form-item prop="proposedCompanyType3" ref="proposedCompanyType3" class="inlineSuffix">
            <el-select v-model="dataForm.proposedCompanyType3" class="wd160">
              <el-option v-for="item in companySuffixTypeList[dataForm.companyType]" :key="`proposedCompanyType3-${item}`" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-form-item>
        <el-form-item label="">
          <p class="fs12 lh16 crgy919 wd500 taj">
            {{ $t("enroll.intitle.businessExplain") }}
          </p>
        </el-form-item>
      </div>
    </div>

    <!-- 主营业务 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.intitle.main") }}</p>
      <div class="pt36">
        <el-form-item :label="$t('enroll.intitle.main')" prop="primaryActivity" ref="primaryActivity">
          <el-select v-model="dataForm.primaryActivity" filterable :placeholder="$t('common.placeholder.select')" class="wd500" popper-class="tradeWrap">
            <el-option v-for="(item, index) in getTradeNewFormatList" :key="`main-trade-${index}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <info-popover
            placement="bottom"
            :title="$t('common.reference')"
            :links="[
              { zh: 'https://www.acra.gov.sg/docs/default-source/_systemdoc/step-by-step-guide.pdf' },
              { zh: 'https://www.singstat.gov.sg/-/media/files/standards_and_classifications/industrial_classification/ssic2020report.ashx' },
            ]"
          ></info-popover>
        </el-form-item>
        <el-form-item :label="$t('enroll.intitle.mainDescribe')" prop="primaryActivityDescription" ref="primaryActivityDescription">
          <el-input
            type="textarea"
            v-model="dataForm.primaryActivityDescription"
            :rows="4"
            :placeholder="$t('common.placeholder.enter')"
            class="wd500"
            maxlength="78"
            show-word-limit
            v-regexFilter="$halfWidthRegex"
          ></el-input>
          <p class="pt10 fs12 lh16 crgy919 wd500 taj">
            {{ $t("enroll.intitle.commonDescribe") }}
          </p>
        </el-form-item>
      </div>
    </div>

    <!-- 次主营业务 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.intitle.minor") }}</p>
      <div class="pt36">
        <el-form-item :label="$t('enroll.intitle.minor')" prop="secondaryActivity" ref="secondaryActivity">
          <el-select v-model="dataForm.secondaryActivity" filterable :placeholder="$t('common.placeholder.select')" class="wd500" popper-class="tradeWrap">
            <el-option v-for="(item, index) in getTradeNewFormatList" :key="`second-trade-${index}`" :label="item.label" :value="item.value"></el-option>
          </el-select>
          <info-popover
            placement="bottom"
            :title="$t('common.reference')"
            :links="[
              { zh: 'https://www.acra.gov.sg/docs/default-source/_systemdoc/step-by-step-guide.pdf' },
              { zh: 'https://www.singstat.gov.sg/-/media/files/standards_and_classifications/industrial_classification/ssic2020report.ashx' },
            ]"
          ></info-popover>
        </el-form-item>
        <el-form-item :label="$t('enroll.intitle.minorDescribe')" prop="secondaryActivityDescription" ref="secondaryActivityDescription">
          <el-input
            type="textarea"
            v-model="dataForm.secondaryActivityDescription"
            :rows="4"
            :placeholder="$t('common.placeholder.enter')"
            class="wd500"
            maxlength="78"
            show-word-limit
            v-regexFilter="$halfWidthRegex"
          ></el-input>
          <p class="pt10 fs12 lh16 crgy919 wd500 taj">
            {{ $t("enroll.intitle.commonDescribe") }}
          </p>
        </el-form-item>
      </div>
    </div>

    <!-- 股东/董事信息 -->
    <div class="pt50 messageWrap">
      <p class="messageTitle">{{ $t("enroll.intitle.detailsTitle") }}</p>
      <div class="pt36">
        <el-form-item :label="$t('enroll.intitle.detailsTitleLower')" prop="companyMemberList" ref="companyMemberList">
          <shareholder-director-information v-model="dataForm.companyMemberList" ref="shareholderDirectorInformationRef" :isReadonly="isReadonly" />
        </el-form-item>
        <el-form-item label="" prop="hasNomineeDirector" ref="hasNomineeDirector" class="agreementWrap" v-if="applymentHasNomineeDirector">
          <el-checkbox v-model="dataForm.hasNomineeDirector" :true-label="1" :false-label="0">{{ $t("enroll.intitle.check") }}</el-checkbox>
        </el-form-item>
      </div>
    </div>
  </el-form>
</template>

<script>
import ShareholderDirectorInformation from "../../components/ShareholderDirectorInformation";
import { validateLocation, strToNum } from "@/utils/common";
import validatorMixin from "@/mixins/validatorMixin";
import { mapState, mapGetters } from "vuex";
export default {
  name: "EnrollIntitleSingapore",
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ShareholderDirectorInformation,
  },
  mixins: [validatorMixin],
  data() {
    return {
      dataForm: {
        companyType: null,
        proposedCompanyName1: null,
        proposedCompanyType1: null,
        proposedCompanyName2: null,
        proposedCompanyType2: null,
        proposedCompanyName3: null,
        proposedCompanyType3: null,
        primaryActivity: null,
        primaryActivityDescription: null,
        secondaryActivity: null,
        secondaryActivityDescription: null,
        companyMemberList: [],
        hasNomineeDirector: null,
      },
      rules: {
        companyType: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        proposedCompanyName1: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        proposedCompanyName2: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        proposedCompanyName3: [
          {
            required: true,
            message: this.$t("common.placeholder.enter"),
            trigger: "submit",
          },
        ],
        proposedCompanyType1: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        proposedCompanyType2: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        proposedCompanyType3: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        primaryActivity: [
          {
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
        companyMemberList: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.replenish"),
            trigger: "submit",
          },
        ],
        hasNomineeDirector: [
          {
            required: true,
            validator: this.validateMustCheckbox,
            trigger: "submit",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("applyment", ["applymentDetail", "applymentHasNomineeDirector"]),
    ...mapState("constant", ["companySuffixTypeList"]),
    ...mapGetters("constant", ["globalFormatList", "getTradeNewFormatList"]),
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 公司类型改变时
    typeChange() {
      this.$set(this.dataForm, "proposedCompanyType1", null);
      this.$set(this.dataForm, "proposedCompanyType2", null);
      this.$set(this.dataForm, "proposedCompanyType3", null);
    },
    // 数据初始化处理
    dataInit() {
      const detail = JSON.parse(JSON.stringify(this.applymentDetail));
      // 字段名已与接口一致，直接取值
      this.dataForm = {
        companyType: detail.companyType || null,
        proposedCompanyName1: detail.proposedCompanyName1 || null,
        proposedCompanyType1: detail.proposedCompanyType1 || null,
        proposedCompanyName2: detail.proposedCompanyName2 || null,
        proposedCompanyType2: detail.proposedCompanyType2 || null,
        proposedCompanyName3: detail.proposedCompanyName3 || null,
        proposedCompanyType3: detail.proposedCompanyType3 || null,
        primaryActivity: detail.primaryActivity || null,
        primaryActivityDescription: detail.primaryActivityDescription || null,
        secondaryActivity: detail.secondaryActivity || null,
        secondaryActivityDescription: detail.secondaryActivityDescription || null,
        companyMemberList: detail.companyMemberList || [],
        hasNomineeDirector: strToNum(detail.hasNomineeDirector),
      };
    },
    // 获取提交参数(由父级触发) - 含业务校验
    getParamsData() {
      // 公司名不能包含后缀
      let suffixList = this.companySuffixTypeList[this.dataForm.companyType];
      for (let i in suffixList) {
        if (this.dataForm.proposedCompanyName1 != null && this.dataForm.proposedCompanyName1.indexOf(suffixList[i]) != -1) {
          this.$message.warning(this.$t("enroll.intitle.businessExplain"));
          validateLocation({ proposedCompanyName1: {} }, this);
          return false;
        }

        if (this.dataForm.proposedCompanyName2 != null && this.dataForm.proposedCompanyName2.indexOf(suffixList[i]) != -1) {
          this.$message.warning(this.$t("enroll.intitle.businessExplain"));
          validateLocation({ proposedCompanyName2: {} }, this);
          return false;
        }

        if (this.dataForm.proposedCompanyName3 != null && this.dataForm.proposedCompanyName3.indexOf(suffixList[i]) != -1) {
          this.$message.warning(this.$t("enroll.intitle.businessExplain"));
          validateLocation({ proposedCompanyName3: {} }, this);
          return false;
        }
      }

      let companyMemberList = this.dataForm.companyMemberList;
      // 公司类型判定标准
      if (this.dataForm.companyType != "Private Company Limited by Shares") {
        // 公司类型下含有股东，就提示
        const hasShares = companyMemberList.findIndex(i => i.dutyType === "CORPORATE" && i.positionHeld === "SHAREHOLDER") !== -1;
        // 个人类型下的股东如果超过20个，就提示
        const individualShareholderList = companyMemberList.filter(
          i => i.dutyType === "INDIVIDUAL" && (i.positionHeld === "SHAREHOLDER" || i.positionHeld === "DIRECTOR_AND_SHAREHOLDER"),
        );

        if (hasShares || individualShareholderList.length > 20) {
          this.$message.warning(this.$t("enroll.intitle.companyTypeRule"));
          validateLocation({ companyType: {} }, this);
          return false;
        }
      }

      return {
        ...this.dataForm,
      };
    },
    // 触发必填校验(由父级触发) - 仅下一步时调用
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            // 校验股东/董事信息
            if (this.$refs.shareholderDirectorInformationRef && !this.$refs.shareholderDirectorInformationRef.validate()) {
              reject("custom prompt: Shareholder/Director validation failed");
              return;
            }
            resolve();
          } else {
            validateLocation(object, this);
            reject("custom prompt: Form verification failed");
          }
        });
      });
    },
  },
  created() {
    // isReadonly 时，applymentDetail 已存在于 vuex，自行初始化数据
    if (this.isReadonly) {
      this.dataInit();
    }
  },
};
</script>

<style lang="scss" scoped>
.dataForm ::v-deep {
  .el-form-item__label {
    height: 38px;
    line-height: 16px;
    display: flex;
    align-items: center;
    text-align: left;
    /* word-break: break-all; */
  }
}

.messageTitle {
  /* border-left: 2px solid #409eff; */
  border-radius: 2px;
  font-size: 16px;
  /* padding-left: 6px; */
  line-height: 1em;
  font-weight: 600;
}

.prependInput ::v-deep {
  .el-input-group__prepend {
    background: #fff;
  }
}

.lineFeed {
  white-space: initial !important;
  word-wrap: break-word !important;
  word-break: break-all !important;
  height: auto !important;
  line-height: 22px;
  padding-top: 4px;
  text-align: justify;
}

.agreementWrap {
  ::v-deep {
    .el-checkbox__label {
      width: 98%;
      white-space: initial;
      /* word-wrap: break-word; */
      /* word-break: break-all; */
      font-size: 14px;
      vertical-align: top;
      margin-top: 8px;
    }
  }
}

.companyWrap {
  ::v-deep {
    .el-input {
      vertical-align: middle;
    }

    .el-select {
      .el-input__inner {
        font-size: 12px;
      }
    }

    /* 嵌套的后缀选择器 form-item：行内显示，无标签、无额外边距 */
    .inlineSuffix {
      display: inline-block;
      margin-bottom: 0;
    }
  }
}
</style>
